import React, { useState } from 'react';
import { makeStyles, withStyles } from 'utils/makeStylesAdapter';
import clsx from 'clsx';
import { Card, Typography, Grid, Tooltip, Box, Divider, Checkbox } from '@mui/material';
import Moment from 'react-moment';
import '../../font.css';
import { StepTitle } from '../';
import LockIcon from '@mui/icons-material/Lock';
import HeadsetIcon from '@mui/icons-material/Headset';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PolicyIcon from '@mui/icons-material/Policy';
import ReportIcon from '@mui/icons-material/Report';
import { verifyMaskInquiryNumber } from 'utils/genericFunctions/formatedInquiryNumber';
import { limitLengthString } from 'utils/limitLengthString';
import HelpIcon from '@mui/icons-material/Help';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useSelector } from 'react-redux';
import {
  DEADLINE_COLORS,
  getColorForDeadline,
} from 'utils/genericFunctions/getColorForTaskDeadline';
import { useCustomerConfig } from 'hooks/useCustomerConfig';
import { STEPS_INQUIRY } from 'constants/inquirys/stepsInquiry';
import { isInfraction } from 'utils/isInfraction';
import { useIsTruncated } from 'hooks/useIsTruncated';
import GroupsIcon from '@mui/icons-material/Groups';
import ArchiveIcon from '@mui/icons-material/Archive';
import { useParameterKeys } from 'hooks/useParameterKeys';
import ModalNoticeAgreementNoncompliance from '../ModalNoticeAgreementNoncompliance/ModalNoticeAgreementNoncompliance';
import ModalSuggestArchiving from '../ModalSuggestArchiving/ModalSuggestArchiving';
import { useFilterInquiry } from 'hooks/useFilterInquiry';

const HtmlTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: 'rgba(112,112,112,0.95)',
    color: 'rgba(112,112,112,0.95)',
  },
}))(Tooltip);

const CardInquiry = props => {
  const { className, backgroundColor, inquiry, ...rest } = props;
  const { inquiryDisplayCrimes } = useSelector(state => state.customerConfig);
  const { consolidatedView } = useSelector(state => state.consolidatedView);
  const [showModal, setShowModal] = useState(false);
  const [localNotifiedState, setLocalNotifiedState] = useState(
    inquiry.wasNotifiedNoncomplianceAgreement,
  );
  const [changedCheckbox, setChangedCheckbox] = useState(inquiry.wasNotifiedNoncomplianceAgreement);
  const [showArchiveModal, setShowArchiveModal] = useState(false);

  const useStyles = makeStyles(theme => ({
    root: {
      boxSizing: 'border-box',
      boxShadow: '0 0 0 1px rgb(63 63 68 / 5%), 0 3px 3px 0 rgb(163 163 163)',
      height: '100%',
      width: '100%',
      cursor: 'pointer',
    },
    shadow: {
      width: '100%',
      height: '100%',
      padding: theme.spacing(1, 1, 1, 2),
      boxShadow: `7px 0px 0px 0px ${backgroundColor} inset`,
    },
    labelCard: {
      color: '#000',
      fontSize: 14,
      fontFamily: 'roboto-regular',
      textAlign: 'center',
    },
    labelComum: {
      fontFamily: 'roboto-regular',
    },
    classBold: {
      fontWeight: 'bold',
    },
    titleCard: {
      color: '#000',
      fontWeight: 'bold',
      fontSize: 15,
      marginTop: 10,
      fontFamily: 'roboto-regular',
    },
    numeroInterno: {
      color: '#000',
      fontWeight: 'bold',
      fontSize: 13,
      fontFamily: 'roboto-regular',
    },
    cardUserInfo: {
      padding: 5,
      paddingLeft: 10,
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
      fontSize: 13,
      fontFamily: 'roboto-regular',
    },
    small: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      backgroundColor: '#000',
      marginTop: theme.spacing(1),
    },
    divScroll: {
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: 0,
      },
      maxHeight: 150,
      minHeight: 120,
      textAlign: 'left',
    },
    topDivScroll: {
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: 0,
      },
      maxHeight: 85,
    },
    divider: {
      backgroundColor: backgroundColor,
    },
    containerType: {
      color: '#000',
      paddingRight: theme.spacing(0.5),
    },
    containerIsArrested: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      minHeight: 30,
    },
    prosecutorTooltip: {
      color: '#FFF',
    },
    checkboxNotice: {
      padding: '2px',
      marginLeft: '4px',
      '& .MuiSvgIcon-root': {
        fontSize: '18px',
      },
    },
  }));

  const classes = useStyles();
  const { isMPDFT, inquiryDisplaySubjects, allOriginNumbersAreNpu } = useParameterKeys();
  const { inquiryStatusContext } = useFilterInquiry();

  const shouldShowNoticeCheckbox = () => {
    if (!isMPDFT || inquiry.instituteExpiredBy60Days || inquiry.instituteExpired) {
      return false;
    }

    return inquiry.hasPenaltiesExpired;
  };

  const handleNoticeCheckboxClick = event => {
    setChangedCheckbox(!inquiry.wasNotifiedNoncomplianceAgreement);
    event.stopPropagation();
    setShowModal(true);
  };

  const handleNoticeSuccess = newValue => {
    setLocalNotifiedState(newValue);
    inquiry.wasNotifiedNoncomplianceAgreement = newValue;
  };

  const TypographyData = props => {
    const { children, variant = 'h6', align = 'left', noWrap } = props;

    const { ref, isTruncated } = useIsTruncated();

    return (
      <Tooltip title={isTruncated ? children : ''} placement="right" arrow>
        <Typography
          variant={variant}
          ref={ref}
          noWrap={Boolean(noWrap)}
          style={{ width: '100%', color: '#000', padding: 0, margin: 0, textAlign: align }}
        >
          {children}
        </Typography>
      </Tooltip>
    );
  };

  const getCrimeOrSubject = () => {
    const crimes = inquiryDisplaySubjects
      ? inquiry.inquiry?.crimeSubjects
      : inquiryDisplayCrimes
      ? inquiry?.crimes
      : null;
    let crimeResult;
    if (!inquiryDisplaySubjects && !inquiryDisplayCrimes) {
      return 'Não informado';
    } else {
      if (inquiryDisplaySubjects) {
        crimeResult =
          crimes?.length >= 1
            ? ' ' +
              limitLengthString(
                crimes[0].hierarchy
                  .split(':')
                  .slice(1)
                  .join(':'),
                25,
              )
            : 'Não informado';
      } else if (inquiryDisplayCrimes) {
        crimeResult =
          crimes?.length >= 1 ? ' ' + limitLengthString(crimes[0].taxonomy, 25) : 'Não informado';
      }
      return crimeResult;
    }
  };

  const CircularIndicator = (title, color) => {
    return (
      <Tooltip arrow title={title} placement="top">
        <FiberManualRecordIcon fontSize="small" style={{ color: color, marginLeft: '4px' }} />
      </Tooltip>
    );
  };

  const renderIndicators = () => {
    const indicators = [];

    if (
      inquiry.step === STEPS_INQUIRY.ANALISE &&
      inquiry?.hearings?.some(hearing => hearing.status === 'CONFIRMED')
    ) {
      indicators.push({
        title: 'Audiência pendente',
        color: DEADLINE_COLORS.RED,
      });
    }

    if (inquiry.daysToMovementTaskDeadline) {
      indicators.push({
        title: `Prazo tarefas: ${inquiry.daysToMovementTaskDeadline} dia(s)`,
        color: getColorForDeadline(inquiry.daysToMovementTaskDeadline),
      });
    }

    if (inquiry.daysToVictimIntimationDeadline) {
      indicators.push({
        title: `Prazo para envio de documentos a vítima: ${inquiry.daysToVictimIntimationDeadline} dia(s)`,
        color: getColorForDeadline(inquiry.daysToVictimIntimationDeadline),
      });
    }

    if (inquiry.pending && !isMPDFT) {
      indicators.push({
        title: 'Há parcela em atraso',
        color: DEADLINE_COLORS.RED,
      });
    }

    if (
      inquiry.step === STEPS_INQUIRY.TRAMITACAO_CONTROLE &&
      inquiry.inquiry?.hasDiligenceResponse &&
      (!inquiryStatusContext || inquiryStatusContext === 'processing-diligence')
    ) {
      indicators.push({
        title: 'Requisitório recebido',
        color: DEADLINE_COLORS.GREEN,
      });
    }

    if (inquiry.inquiry.isCrimeAgainstChild) {
      indicators.push({
        title: 'Crime contra Criança e Adolescente',
        color: DEADLINE_COLORS.PURPLE,
      });
    }

    if (inquiry.instituteExpiredBy60Days && isMPDFT) {
      indicators.push({
        title: 'Instituto vencido há mais de 60 dias',
        color: DEADLINE_COLORS.BLACK,
      });
    } else if (inquiry.instituteExpired && isMPDFT) {
      indicators.push({
        title: 'Instituto vencido',
        color: DEADLINE_COLORS.RED,
      });
    } else if (
      inquiry.wasNotifiedNoncomplianceAgreement &&
      isMPDFT &&
      inquiry.hasPenaltiesExpired
    ) {
      indicators.push({
        title: 'Noticiado o descumprimento à Promotoria de origem',
        color: DEADLINE_COLORS.YELLOW,
      });
    } else if (inquiry.hasPenaltiesExpired && isMPDFT) {
      indicators.push({
        title: 'Medidas vencidas',
        color: DEADLINE_COLORS.ORANGE,
      });
    }

    return indicators;
  };

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <Box className={classes.shadow}>
        <Grid spacing={0} style={{ position: 'relative' }}>
          <Box className={classes.topDivScroll}>
            <TypographyData>
              {verifyMaskInquiryNumber(
                inquiry.inquiry?.policeInquiryNumber,
                inquiry.inquiry?.classeDescription,
                allOriginNumbersAreNpu,
              )}
            </TypographyData>
            <TypographyData>
              {inquiry.inquiry.internalSystemNumber
                ? inquiry.inquiry.arquimedesAuto
                  ? `${inquiry.inquiry.internalSystemNumber} ${inquiry.inquiry.arquimedesAuto}`
                  : `${inquiry.inquiry.internalSystemNumber}`
                : 'Número não disponível'}
            </TypographyData>
            <TypographyData>{inquiry.investigated.name}</TypographyData>
            <StepTitle variant="h6" className={classes.labelCard} step={inquiry.step} />
          </Box>
          <Grid
            style={{
              right: 0,
              top: 0,
              position: 'absolute',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            {renderIndicators().map((indicator, index) => (
              <React.Fragment key={index}>
                {CircularIndicator(indicator.title, indicator.color)}
              </React.Fragment>
            ))}
            {inquiry.step === STEPS_INQUIRY.ANALISE && inquiry.suggestArchiving && (
              <Tooltip title="Visualizar sugestão de arquivamento interno" arrow placement="top">
                <ArchiveIcon
                  fontSize="small"
                  style={{ marginLeft: '4px', cursor: 'pointer', color: '#555' }}
                  onClick={e => {
                    e.stopPropagation();
                    setShowArchiveModal(true);
                  }}
                />
              </Tooltip>
            )}
            {shouldShowNoticeCheckbox() && (
              <Tooltip
                title={
                  inquiry.agreementNoncomplianceNoticeObservation
                    ? `Notificar descumprimento: ${inquiry.agreementNoncomplianceNoticeObservation}`
                    : 'Notificar descumprimento'
                }
                arrow
                placement="top"
              >
                <Checkbox
                  checked={localNotifiedState}
                  className={classes.checkboxNotice}
                  color="primary"
                  size="small"
                  onClick={handleNoticeCheckboxClick}
                />
              </Tooltip>
            )}
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <Grid container spacing={0} className={classes.divScroll}>
          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <TypographyData noWrap>
              Classe:{' '}
              {`${inquiry.inquiry?.classe || 'código não informado'}, ${inquiry.inquiry
                ?.classeDescription || 'classe não informada'}`}
            </TypographyData>
          </Grid>
          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <TypographyData noWrap>
              Grupo Ofício: {inquiry.inquiry?.prosecutorOfficeGroup?.name || 'não informado'}
            </TypographyData>
          </Grid>

          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <TypographyData>
              CPF do investigado: {inquiry.investigated.taxpayerRegistry || 'não informado'}
            </TypographyData>
          </Grid>

          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <TypographyData>
              RG do Investigado: {inquiry?.investigated?.rg?.code || 'não informado'}
            </TypographyData>
          </Grid>

          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <TypographyData noWrap>
              {isInfraction(inquiry.inquiry?.classe) ? 'Ato Infracional' : 'Crime'} cometido:
              {getCrimeOrSubject()}
            </TypographyData>
          </Grid>

          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <TypographyData>
              Recebido em:{' '}
              <Moment format="DD/MM/YYYY" local>
                {inquiry.createdAt}
              </Moment>
            </TypographyData>
          </Grid>
          {inquiry.step === STEPS_INQUIRY.ANALISE && inquiry?.lastDistribution?.createdAt && (
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <TypographyData>
                Distribuído em:{' '}
                <Moment format="DD/MM/YYYY" local>
                  {inquiry?.lastDistribution?.createdAt}
                </Moment>
              </TypographyData>
            </Grid>
          )}
        </Grid>
        <Box>
          <Grid
            className={classes.containerIsArrested}
            size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Box display="flex" alignItems="center">
              {inquiry.inquiry.status ? (
                <HtmlTooltip
                  arrow
                  title={
                    <Typography variant="body2" className={classes.prosecutorTooltip}>
                      {inquiry.inquiry.status}
                    </Typography>
                  }
                  placement="top"
                >
                  <HelpIcon fontSize="small" />
                </HtmlTooltip>
              ) : null}
              {inquiry.isArrested ? (
                <HtmlTooltip
                  arrow
                  title={
                    <Typography variant="body2" className={classes.prosecutorTooltip}>
                      Encontra-se preso
                    </Typography>
                  }
                  placement="top"
                >
                  <LockPersonIcon fontSize="small" />
                </HtmlTooltip>
              ) : null}
              {inquiry.inquiry.prosecutor && (
                <HtmlTooltip
                  arrow
                  title={
                    <>
                      <Typography variant="body2" className={classes.prosecutorTooltip}>
                        Promotor: {inquiry.inquiry.prosecutor.name}
                      </Typography>
                      {inquiry.inquiry.prosecutorOffice && (
                        <Typography variant="body2" className={classes.prosecutorTooltip}>
                          Promotoria: {inquiry.inquiry.prosecutorOffice.name}
                        </Typography>
                      )}
                    </>
                  }
                  placement="right"
                >
                  <AccountCircleIcon fontSize="small" />
                </HtmlTooltip>
              )}
              {inquiry.inquiry.isConfidential ? (
                <HtmlTooltip
                  arrow
                  title={
                    <Typography variant="body2" className={classes.prosecutorTooltip}>
                      {isMPDFT ? 'Processo Sigiloso' : 'Inquérito confidencial'}
                    </Typography>
                  }
                  placement="top"
                >
                  <LockIcon fontSize="small" />
                </HtmlTooltip>
              ) : null}
              {inquiry.awaitingInstitutionResponse ? (
                <HtmlTooltip
                  arrow
                  title={
                    <Typography variant="body2" className={classes.prosecutorTooltip}>
                      Atribuição PM
                    </Typography>
                  }
                  placement="top"
                >
                  <PolicyIcon fontSize="small" />
                </HtmlTooltip>
              ) : null}
              {inquiry.inquiry?.fact?.isFlagrant ? (
                <HtmlTooltip
                  arrow
                  title={
                    <Typography variant="body2" className={classes.prosecutorTooltip}>
                      Flagrante
                    </Typography>
                  }
                  placement="top"
                >
                  <ReportIcon fontSize="small" />
                </HtmlTooltip>
              ) : null}
              {inquiry.inquiry?.hasDiligenceResponse ? (
                <HtmlTooltip
                  arrow
                  title={
                    <Typography variant="body2" className={classes.prosecutorTooltip}>
                      Requisitório
                    </Typography>
                  }
                  placement="top"
                >
                  <CheckCircleIcon fontSize="small" />
                </HtmlTooltip>
              ) : null}
              {inquiry.isService && (
                <HtmlTooltip
                  arrow
                  title={
                    <>
                      <Typography variant="body2" className={classes.prosecutorTooltip}>
                        Atendimento
                      </Typography>
                    </>
                  }
                  placement="right"
                >
                  <HeadsetIcon fontSize="small" />
                </HtmlTooltip>
              )}
              {consolidatedView && inquiry.investigatedNames?.length > 1 && (
                <HtmlTooltip
                  arrow
                  title={
                    <>
                      <Typography variant="body2" className={classes.prosecutorTooltip}>
                        Investigados: {inquiry.investigatedNames.join(', ')}
                      </Typography>
                    </>
                  }
                  placement="right"
                >
                  <GroupsIcon fontSize="small" />
                </HtmlTooltip>
              )}
            </Box>
            <div>
              <Typography variant="body1" className={classes.containerType}>
                {inquiry.isProbableNonPersecution ? 'Não persecução' : 'Persecução'}
              </Typography>
            </div>
          </Grid>
        </Box>
      </Box>
      <div onClick={e => e.stopPropagation()}>
        <ModalNoticeAgreementNoncompliance
          inquiry={inquiry}
          edit={true}
          open={showModal}
          wasNotifiedNoncomplianceAgreement={changedCheckbox}
          onClose={() => setShowModal(false)}
          onSuccess={handleNoticeSuccess}
        />
        <ModalSuggestArchiving
          open={showArchiveModal}
          onClose={() => setShowArchiveModal(false)}
          justification={inquiry.suggestArchivingJustification}
          file={inquiry.suggestArchivingFile}
        />
      </div>
    </Card>
  );
};

export default CardInquiry;
